export enum ResponseMessage {
  UnableToComplete = 'Unable to complete operation',
  RequestCanceled = 'Request canceled'
}